<template>
  <b-card class="card" no-body>
    <b-container class="template">
      <b-row class="title-row-margin">
        <b-col cols="12">
          <div class="sentiment-title">
            Clustering
          </div>
        </b-col>
      </b-row>
      <b-row class="service-section">
        <b-col class="service-col">
          <b-container class="service-container">
            <b-row class="service-row-margin">
              <IconDetail
                icon="/assets/images/th-list-solid.png"
                title="แบ่งกลุ่มข้อความตามความใกล้เคียงของประโยค"
                description="โดยไม่ต้องเตรียมตัวอย่างข้อความ และ train model"
              />
            </b-row>
            <b-row class="service-row-margin">
              <IconDetail
                icon="/assets/images/text-document.png"
                title="เตรียมข้อความและจำนวนของกลุ่มที่คาดว่าจะพบในข้อความ"
                description="และส่งให้ model ได้เลยโดยไม่ตอง train ก่อนเหมือน classification"
              />
            </b-row>
            <b-row>
              <IconDetail
                icon="/assets/images/folder.png"
                title="Model จะแบ่งข้อความออกเป็นกลุ่มตามจำนวนที่กำหนด"
                description="โดยดูจากความใกล้เคียงของคำศัพท์ในข้อความ"
              />
            </b-row>
          </b-container>
        </b-col>
        <b-col class="image-col">
          <b-container class="image-container">
            <img class="image" src="/assets/images/clustering.svg">
          </b-container>
        </b-col>
      </b-row>
      <b-row class="example">
        <b-col class="example-col">
          <b-container class="example-container">
            <b-row class="example-row-margin">
              <div class="example-title">
                ตัวอย่างการใช้งาน Clustering - การจัดกลุ่มข้อความ
              </div>
            </b-row>
            <b-row>
              <div ref="clusteringAnimPlaceholder" />
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="button-section">
        <div class="try-button" @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'clustering_home_page', linkTo: 'clustering' })">
          <router-link
            to="/demo/clustering"
            class="btn btn-primary"
            exact
            tag="button"
          >
            ทดลองใช้งาน
          </router-link>
        </div>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import clusteringAnimationData from '../../data/ClusteringAnimationData'
import lottie from 'lottie-web'
import IconDetail from './IconDetail'
import { BCard, BContainer, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  name: 'ClusteringCard',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    IconDetail
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  mounted () {
    this.startClusteringAnimation()
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    }),
    startClusteringAnimation () {
      lottie.loadAnimation({
        container: this.$refs.clusteringAnimPlaceholder,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: clusteringAnimationData
      })
    }
  }
}
</script>

<style scoped>

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        width: 100%;
        height: 100%;
        padding: 48px;
    }

    .sentiment-title {
        color: #48465B;
        opacity: 1;
        font-size: 26px;
        font-weight: 600;
    }

    .title-row-margin {
        margin-bottom: 28px;
    }

    .service-row-margin {
        margin-bottom: 36px;
    }

    .example-row-margin {
        margin-bottom: 16px;
    }

    .example-title {
        font-size: 20px;
        color: #48465B;
        font-weight: 600;
        text-align: center;
        margin-right: auto;
        margin-left: auto;
    }

    .image {
        max-height: 288px;
    }

    .example {
        margin-bottom: 40px;
    }

    @media (max-width: 1025px) {
        [class*="service-col col-"] {
            margin-bottom: 60px;
        }
    }

    .service-section {
        margin-bottom: 48px;
    }

    .try-button {
        margin-left: auto;
        margin-right: auto;
    }

    @media (max-width: 1379px) {
        .image-col {
            display: none;
        }

        .service-container > * {
            position: relative;
            z-index: 2;
        }

        .service-container::after {
            content: "";
            background-image: url('/assets/images/clustering.svg');
            background-repeat: no-repeat;
            background-position: center;
            opacity: 0.3;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>
